import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { SelectData } from '../form/select/model';

@Component({
  selector: 'smarsh-custom-dropdown-btn',
  templateUrl: 'custom-dropdown-btn.component.html',
  styleUrls: ['./custom-dropdown-btn.component.scss']
})
export class CustomDropdownBtnComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  list: SelectData[];

  @Input()
  popupStyle: 'dropup' | 'dropdown' = 'dropdown';

  @Input()
  btnStyle: '' | 'btn-secondary' | 'btn-outline-primary' = '';

  @Input()
  btnTextStyle: '' | 'btn-text-white' = '';

  @Input()
  id = 'dropdownMenu';

  @Input()
  btnSize: '' | 'dropdown-btn-large' = '';

  @Input()
  dropMenuAlignment: '' | 'dropdown-menu-right' = '';

  @Input()
  btnFixSize: '' | '100' = '';

  btnStyleDefault = 'btn dropdown-toggle';

  dropMenuDefault = 'dropdown-menu dropdown-cursor';

  btnLabelDefault = 'd-inline-block text-truncate btn-label-size';

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  change = new EventEmitter<SelectData>();

  toggle: boolean;

  @Input()
  convertToIcon: boolean;

  iconSrc: string;

  ngOnInit() {
    if (this.convertToIcon) {
      this.btnStyleDefault = 'btn pr-4';
    }
    this.btnStyleDefault = this.btnStyleDefault
      .concat(' ')
      .concat(this.btnStyle)
      .concat(' ')
      .concat(this.btnTextStyle)
      .concat(' ')
      .concat(this.btnSize);

    this.btnLabelDefault = this.btnLabelDefault.concat(' ');
    this.dropMenuDefault = this.dropMenuDefault
      .concat(' ')
      .concat(this.dropMenuAlignment);
    this.findSelectedLabel();
    this.updateIconUrl();
  }
  findSelectedLabel() {
    const selectedData = this.list.find((value) => value.id === this.label);
    if (selectedData) {
      this.label = selectedData.name;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event) {
    if (this.toggle && event.target && event.target.id !== this.id) {
      this.toggle = false;
    }
  }

  onKeydown(event: KeyboardEvent, item: SelectData) {
    // Check if the Enter or Space key was pressed
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onClick(item);
    }
  }

  onClick(item: SelectData) {
    this.toggle = false;
    this.change.emit(item);
    this.findSelectedLabel();
  }

  updateIconUrl() {
    this.iconSrc = this.generateAvatar(this.label);
  }

  generateAvatar(name) {
    if (!name) {
      return;
    }
    const initials = name
      .split(' ')
      .map((str: string) => (str ? str[0].toUpperCase() : ''))
      .join('');
    const canvas = document.createElement('canvas');
    const radius = 30;
    const margin = 5;
    canvas.width = radius * 2 + margin * 2;
    canvas.height = radius * 2 + margin * 2;

    // Get the drawing context
    const ctx = canvas.getContext('2d');
    ctx.beginPath();
    ctx.arc(radius + margin, radius + margin, radius, 0, 2 * Math.PI, false);
    ctx.closePath();
    ctx.fillStyle = 'grey';
    ctx.fill();
    ctx.fillStyle = 'white';
    ctx.font = 'bold 30px Arial';
    ctx.textAlign = 'center';
    ctx.fillText(initials, radius + 5, (radius * 4) / 3 + margin);
    return canvas.toDataURL();
  }
}
